module.exports = __webpack_public_path__ + "img/Advantage@2x.dcf5e5ae.png";